import Bluebird from "bluebird";
import { reactive } from "@vue/composition-api";

import { Session } from "@/tools/msa/models";
import { mode } from "@/tools/msa/utils/collections";
import { getAllPatientNames } from "@/tools/msa/utils/names/patient";
import { makePartialDocument } from "@/tools/msa/processing/document";
import { encodeDocumentWithSnomed } from "@/tools/msa/processing/snomed";
import { SuccessfulResponse } from "@/tools/msa/models/requests/extraction/legacy";
import { encodeDocumentWithCustomTerms } from "@/tools/msa/processing/custom";

export const makeSession = async (
  id: string,
  file: File,
  response: SuccessfulResponse
): Promise<Session> => {
  const session: Session = reactive<Session>({
    id,
    fileId: "",
    file,
    patient: reactive({
      name: "",
      dateOfBirth: null
    }),
    documents: []
  });

  session.documents = await Bluebird.map(
    response.documents,
    async pages => await makePartialDocument(pages, session),
    { concurrency: 6 }
  )
    .then(documents => {
      session.patient.dateOfBirth = mode(
        documents
          .map(document => document.dateOfBirth)
          .filter(Boolean)
          .map(date => date as Date),
        (a, b) => a.getTime() === b.getTime()
      );
      return documents;
    })
    .map(document => encodeDocumentWithSnomed(document, session), {
      concurrency: 6
    })
    .map(document => encodeDocumentWithCustomTerms(document, session), {
      concurrency: 6
    });

  session.patient.dateOfBirth =
    session.documents
      .map(document => document.dateOfBirth)
      .filter(Boolean)
      .pop() || null;

  session.patient.name = getAllPatientNames(session)[0] || "";

  return session;
};
